export default __webpack_public_path__ + "static/media/pin-purple.a8f1dfb7.svg";